/**
 * Converts a stored hours value to a number. An empty or a non-numeric value gives 0.
 */
export function toHoursNumber(value: string | number | null | undefined): number {
  const hours = Number(value);

  return value === null || value === undefined || value === '' || !Number.isFinite(hours) ? 0 : hours;
}
